

import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useAppContext } from '../../hooks/useAppContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme, designMode } = useAppContext();
  const isModern = designMode === 'modern';

  return (
    <button
      onClick={isModern ? undefined : toggleTheme}
      disabled={isModern}
      className={`p-2 rounded-full transition-colors ${isModern ? 'text-slate-300 cursor-not-allowed opacity-60' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'}`}
      aria-label="Toggle Theme"
      title={isModern ? 'الوضع الحديث ثابت على الغامق' : undefined}
    >
      {isModern ? <Moon size={20} /> : (theme === 'light' ? <Moon size={20} /> : <Sun size={20} />)}
    </button>
  );
};
